import { FetchStatus } from 'config/constants/types'
import { useDagenApi } from 'hooks/useDagenApi'
import useSWR from 'swr'
import useReconstructNFT from '../../../../hooks/useReconstructNFT'
import { NftToken } from '../../../../state/nftMarket/types'

const useGetGensForInWallet = (walletAddress) => {
  const { reConstructNftToken } = useReconstructNFT()

  const dagenApi = useDagenApi()
  const { status, data, mutate } = useSWR<NftToken[]>(
    walletAddress ? ['queryInWalletAssert', walletAddress] : null,
    async (url, walletAddress) => {
      const res = await dagenApi.get(url, { params: { walletAddress } })
      const tokens = res.data.result.tokens
      const results = []

      for (let index = 0; index < tokens.length; index++) {
        const token = tokens[index]
        results.push(reConstructNftToken(token))
      }
      const gens = await Promise.all(results)
      return gens
    },
  )

  return {
    tokens: data ?? new Array<NftToken>(),
    isLoading: status !== FetchStatus.Fetched,
    refresh: mutate,
  }
}

export default useGetGensForInWallet
